import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

let createObjectURL =
  (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    currentUser: PropTypes.object.isRequired,
    loadMyCircleWallsFromServer: PropTypes.func.isRequired,
    circleId: PropTypes.number.isRequired,
    isFormShow: PropTypes.bool,
  },
  getInitialState() {
    return {
      body: "",
      isPrivate: false,
      file: {},
      isUploading: false,
    };
  },
  handleBody(e) {
    this.setState({
      body: e.target.value,
    });
  },
  handlePublicStatus(e) {
    this.setState({
      isPrivate: e.target.value,
    });
  },
  handleWallImage(e) {
    if (e.target.files.length > 0) {
      this.setState({
        file: e.target.files[0],
        imageUrl: createObjectURL(e.target.files[0]),
      });
    }
  },
  handleSubmit() {
    this.setState({
      isUploading: true,
    });
    let circleId = this.props.circleId;
    const formData = new FormData();
    if (this.state.file.name !== undefined) {
      formData.append("file", this.state.file);
    }
    formData.append("body", this.state.body);
    formData.append("is_private", this.state.publicStatus);
    formData.append("circle_id", circleId);

    $.ajax({
      url: "/api/wall",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function() {
          this.setState({
            body: "",
            file: {},
            imageUrl: "",
            isUploading: false,
          });
          this.props.loadMyCircleWallsFromServer();
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  componentDidMount() {},
  render() {
    const currentUser = this.props.currentUser;
    return this.props.isFormShow ? (
      currentUser && !currentUser.is_banned ? (
        <div className="fixed-bottom bg-graydark">
          <div className="container col-md-8 col-lg-6 pr-0">
            <div className="input-group pt-2 pb-2">
              <textarea
                className="form-control border-0 rounded h-1em bg-light-gray text-fz-16px"
                style={{ height: 58 }}
                type="text"
                rows="1"
                placeholder="質問・コメントする..."
                onChange={this.handleBody}
                value={this.state.body}
              />
              <div className="input-group-append">
                <button
                  className="btn text-black-50 text-fw-bold pt-1"
                  onClick={this.handleSubmit}
                >
                  送信
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="fixed-bottom bg-graydark">
          <div className="container col-md-8 col-lg-6 pr-0">
            <div className="pt-2 pb-2 text-center">
              <p className="text-fz-11px">
                質問・コメントするには<a
                  href={`/users/sign_in?rurl=/circle/${
                    this.props.circleId
                  }/comments`}
                >
                  ログイン
                </a>が必要です
              </p>
            </div>
          </div>
        </div>
      )
    ) : (
      ""
    );
  },
});
